import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { INITIAL_ADVANCE_FILTER } from 'configs/analytics/configTableOrder'
import { constructOptionsSelect } from 'utils/utils'
import { API_ORDER } from 'services/apiAnalyticOrder'
import { AdvanceFilter } from 'components/analytics/order/AdvanceFilter'

export const AdvanceFilterContainer = ({ show, setShow, values, onSubmit }) => {
    const [filterDetail, setFilterDetail] = useState({})
    const { fetching: getVoucherList } = useFetch(API_ORDER.VOUCHER_LIST)
    const { fetching: getShippingMethods } = useFetch(API_ORDER.SHIPPING_METHODS)
    const { fetching: getPaymentMethods } = useFetch(API_ORDER.PAYMENT_METHODS)
    const [options, setOptions] = useState({
        voucher_codes: [],
        payment_services: [],
        shipping_aliases: [],
    })

    const getFilterCount = () => {
        let count = 0
        Object.keys(values).map((i) => (count += values[i]?.length))
        return count
    }

    const onClear = () => {
        setFilterDetail(INITIAL_ADVANCE_FILTER)
    }

    const onSearchVoucher = (value) => {
        getVoucherList({ search: value }).then((response) => {
            const newOption = constructOptionsSelect(response?.data, 'code', 'code')
            setOptions({ ...options, voucher_codes: newOption })
        })
    }

    const onChangeForm = (e) => {
        const { name, value } = e
        setFilterDetail({ ...filterDetail, [name]: value })
    }

    useEffect(() => {
        if (show) {
            Promise.all([getVoucherList(), getShippingMethods(), getPaymentMethods({ withoutGrouping: true })]).then(
                (response) => {
                    const newOptions = {
                        voucher_codes: constructOptionsSelect(response[0]?.data, 'code', 'code'),
                        shipping_aliases: response[1]?.data,
                        payment_services: response[2]?.data,
                    }
                    setOptions({ ...options, ...newOptions })
                },
            )
        }

        setFilterDetail(values)
    }, [show, values])

    const props = {
        show,
        setShow,
        filterDetail,
        getFilterCount,
        onSearchVoucher,
        onChangeForm,
        onClear,
        options,
        onSubmit,
    }

    return <AdvanceFilter {...props} />
}
